import React, { useContext, useEffect, useMemo, useState } from 'react';
import { BiX } from "react-icons/bi";
import { PatrimonioContext } from '../../../contexts/patrimonioProvider';
import { ClientContext } from '../../../contexts/clientProvider';
import Loader from '../../Loader/load';
import BaseButton from '../../General/FormsComp/Button/BaseButton';
import TabelaPatrimoniosSecretaria from './TabelaPatrimoniosSecretaria';
import VincularNovosPatrimonios from './VincularNovosPatrimonios';

const VincularPatrimonios = ({ secretaria, closeModal }) => {
    const { buscarAllPatrimonios, patLoading, patrimonios } = useContext(PatrimonioContext);
    const { clientes } = useContext(ClientContext);
    const [loading, setLoading] = useState(false);
    const [cliente, setCliente] = useState(null);
    const [step, setStep] = useState('lista'); // 'lista' | 'vincular'
    console.log(patrimonios);
    useEffect(() => {
        if (secretaria?.id_cliente) {
            carregarPatrimonios();
            const clienteEncontrado = clientes?.find(c => c.id === secretaria.id_cliente);
            setCliente(clienteEncontrado);
        }
    }, [secretaria, clientes]);

    const carregarPatrimonios = async () => {
        if (!secretaria?.id_cliente) return;

        setLoading(true);
        try {
            const dados = { id_cliente: secretaria.id_cliente };
            await buscarAllPatrimonios(dados);
        } catch (error) {
            console.error('Erro ao carregar patrimônios:', error);
        } finally {
            setLoading(false);
        }
    };

    const patrimoniosDaSecretaria = useMemo(() => {
        const idSec = Number(secretaria?.id);
        return (patrimonios || [])
            .filter(p => p.nome_anexo !== "ESTOQUE" && p.nome_anexo !== "Estoque" && p.nome_anexo !== "estoque")
            .filter((p) => {
                const secId = Number(p?.secretaria_id ?? p?.id_secretaria);
                return secId && idSec && secId === idSec;
            });
    }, [patrimonios, secretaria]);

    const patrimoniosParaVinculo = useMemo(() => {
        const idSec = Number(secretaria?.id);
        return (patrimonios || [])
            .filter(p => p.nome_anexo !== "ESTOQUE" && p.nome_anexo !== "Estoque" && p.nome_anexo !== "estoque")
            .filter((p) => {
                const secId = Number(p?.secretaria_id ?? p?.id_secretaria);
                return !secId || secId !== idSec;
            });
    }, [patrimonios, secretaria]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 w-11/12 max-w-[95vw] max-h-[95vh] overflow-y-auto border border-gray-200 dark:border-gray-700 shadow-lg">
                {loading || patLoading ? (
                    <Loader />
                ) : (
                    <div className="space-y-3">
                        {/* Informações da Secretaria */}
                        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                <div>
                                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Secretaria</label>
                                    <p className="text-gray-900 dark:text-white font-medium">{secretaria?.nome}</p>
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Cliente</label>
                                    <p className="text-gray-900 dark:text-white font-medium">{cliente?.nome}</p>
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">CNPJ</label>
                                    <p className="text-gray-900 dark:text-white font-medium">{secretaria?.cnpj}</p>
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Email</label>
                                    <p className="text-gray-900 dark:text-white font-medium">{secretaria?.email}</p>
                                </div>
                            </div>
                        </div>

                        {step === 'lista' ? (
                            <TabelaPatrimoniosSecretaria
                                secretaria={secretaria}
                                cliente={cliente}
                                patrimonios={patrimoniosDaSecretaria}
                                onGoToVincular={() => setStep('vincular')}
                            />
                        ) : (
                            <VincularNovosPatrimonios
                                secretaria={secretaria}
                                cliente={cliente}
                                patrimonios={patrimoniosParaVinculo}
                                onBack={() => setStep('lista')}
                                onVinculados={() => carregarPatrimonios()}
                            />
                        )}

                        <div className="pt-2 flex justify-end">
                            <BaseButton onClick={closeModal} variant="primary" size="md">Fechar</BaseButton>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VincularPatrimonios;
